import { z } from 'zod';
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
export function paginatedSchema(item) {
    return z.object({
        items: z.array(item),
        total: z.number().int(),
        page: z.number().int(),
        pageSize: z.number().int(),
    });
}
/** Optional ISO date-time (with offset) or plain date (YYYY-MM-DD) filter. */
export const dateFilterSchema = z.union([z.iso.datetime({ offset: true }), z.iso.date()]);
export const dateRangeQuerySchema = z
    .object({
    from: dateFilterSchema.optional(),
    to: dateFilterSchema.optional(),
})
    .refine((q) => !q.from || !q.to || new Date(q.from) <= new Date(q.to), {
    message: '`from` must be before `to`',
    path: ['from'],
});
/** Query-string boolean: accepts true/false/1/0 explicitly (never Boolean("false")). */
export const queryBooleanSchema = z
    .union([z.boolean(), z.enum(['true', 'false', '1', '0'])])
    .transform((v) => v === true || v === 'true' || v === '1');
//# sourceMappingURL=pagination.js.map